import { useState, useEffect } from "react";
import TextSkeleton from "../../components/SkeletonComponents/TextSkeleton";

const BasicInput = (props) => {
  const [inputValue, setInputValue] = useState(props.initialValue || "");
  const isLoading = props.isLoading;

  useEffect(() => {
    if (props.initialValue) setInputValue(props.initialValue);
  }, [props.initialValue]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleInputBlur = () => {
    props.onBlur(inputValue);
  };

  const handleInputFocus = () => {
    if (props.onFocus) {
      props.onFocus();
    }
  };

  return (
    <div className={`${props.className}`}>
      <label
        htmlFor={props.id}
        className="block text-sm font-medium text-gray-700"
      >
        {props.label}
      </label>
      {!isLoading ? (
        <input
          id={props.id}
          name={props.id}
          type="text"
          autoComplete="off"
          tabIndex={-1}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          placeholder={props.placeholder}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          onFocus={handleInputFocus}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.target.blur();
            }
          }}
        />
      ) : (
        <TextSkeleton height="38px" className="mt-1 w-full" />
      )}
    </div>
  );
};

export default BasicInput;
